module.exports = require("react-select");